import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch, store } from 'store';
import { appSidebarWidth } from 'store/constant';

export interface AppSidebarParams {
  open: boolean;
  width?: number;
  activeId: string | null;
  base?: boolean;
  title?: string;
  closable?: boolean;
  hideHeader?: boolean;
  onClose?: () => void;
  hideBg?: boolean;
  anchor?: 'left' | 'right';
}

const initialState: AppSidebarParams = {
  open: false,
  width: appSidebarWidth,
  activeId: null,
  base: false,
  title: '',
  closable: true,
  hideHeader: false,
  onClose: undefined,
  hideBg: false,
  anchor: 'right',
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarState(state, action: PayloadAction<Partial<AppSidebarParams>>) {
      return { ...state, ...action.payload };
    },
    clearSidebarState(state) {
      return initialState;
    },
  },
});

export const { setSidebarState, clearSidebarState } = sidebarSlice.actions;
export default sidebarSlice.reducer;

export const openAppSidebar = (id: string, params?: Partial<Omit<AppSidebarParams, 'activeId' | 'open'>>) => {
  const { width, ...restParams } = params || {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { open, activeId, width: initialWidth, ...resetParams } = initialState;
  const finalParams = { ...resetParams, ...restParams };
  dispatch(setSidebarState({ open: true, activeId: id, width: width ?? appSidebarWidth, ...finalParams }));
};
export const closeAppSidebar = () => {
  dispatch(setSidebarState({ open: false }));
  setTimeout(() => {
    const sidebarState = store.getState().appSidebar;
    if (sidebarState.open !== true) dispatch(setSidebarState({ ...initialState, width: sidebarState.width }));
  }, 500);
};
export const toggleSidebar = (id: string, params?: Partial<Omit<AppSidebarParams, 'activeId' | 'open'>>) => {
  const currentState = store.getState().appSidebar;
  if (currentState.open && currentState.activeId === id) {
    closeAppSidebar();
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { open, activeId, ...resetParams } = initialState;
    openAppSidebar(id, { ...resetParams, ...params });
  }
};

export const updateSidebar = (params: Partial<AppSidebarParams>) => {
  dispatch(setSidebarState(params));
};
